export default {
  authData: {
    loginDetails: {},
    authenticated: false,
    error: ''
  },
  machineCutting: {
    searchCutting: {},
    addCutting: {},
    updatedCutting: {},
    deleteCutting: {},
    retrievedData: {},
    error: ''
  }
}